export default "__VITE_PUBLIC_ASSET__de4294ba__"